import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import editable from './editable';

/**
 * This decorator/HOC will display both the editable and the widget when in the editing
 * state by leveraging the `editable` decorator/HOC. This is most useful if you need a
 * custom model or some other item to display without losing the original widget.
 *
 * If you're making a fairly standard form modal that's saving to the payload, try using
 * the `editModal` decorator/HOC instead.
 *
 * @param {Object} Editor - the component to use for editing
 * @returns {function(Component: Object): Object} the decorator or HOC to apply to the original component
 */
export default Editor => (Component) => {
  /* eslint-disable react/prefer-stateless-function */
  class EditorWidget extends React.Component {
    render() {
      return (
        <div>
          <Editor {...this.props} />
          <Component {...this.props} />
        </div>
      );
    }
  }
  EditorWidget.displayName = `EditorWidget(${Component.displayName || Component.name})`;

  const HoistedEditor = hoistNonReactStatic(EditorWidget, Component);
  return editable(HoistedEditor)(Component);
};
